// Complementary Products - Simplified version using theme's variant-picker
class ComplementaryProductForm extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form');
    this.submitBtn = this.querySelector('[name="add"]');
    
    if (this.form && theme.settings.afterAddToCart !== 'no-js') {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  async handleSubmit(evt) {
    evt.preventDefault();
    if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

    // Disable button
    this.submitBtn.setAttribute('aria-disabled', 'true');
    this.submitBtn.classList.add('is-loading');

    const formData = new FormData(this.form);
    const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el);
    const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    const fetchRequestOpts = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
      const data = await response.json();
      
      if (!response.ok) throw new Error(response.status);

      // Update cart sections
      if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
        sectionsToUpdate.forEach((el) => {
          el.updateFromCartChange(data.sections[el.dataset.sectionId]);
        });
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }

      // Open drawer if configured
      if (theme.settings.afterAddToCart === 'drawer') {
        document.querySelector('.js-cart-drawer')?.open(this.submitBtn);
      } else if (theme.settings.afterAddToCart === 'notification') {
        const notification = document.getElementById('AddedNotification')?.content.firstElementChild.cloneNode(true);
        if (notification) {
          notification.dataset.productTitle = data.product_title;
          const container = document.querySelector('.pageheader--sticky') || document.body;
          container.appendChild(notification);
        }
      }

      // Success feedback
      this.submitBtn.classList.add('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
      setTimeout(() => {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.classList.remove('is-success');
      }, 2000);
    } catch (error) {
      console.error(error);
      this.submitBtn.classList.remove('is-loading');
      this.submitBtn.removeAttribute('aria-disabled');
    }
  }
}

customElements.define('complementary-product-form', ComplementaryProductForm);
